import yup from "utilities/form/yup";

import { type InputEmailFormValue } from "commonComponents/entity/email/InputEmail/InputEmail.types";
import { InputEmailValidator } from "commonComponents/entity/email/InputEmail/InputEmail.utils";

export const InputEmailListValidator = yup.array().of<InputEmailFormValue>(InputEmailValidator);
